module.exports = __webpack_public_path__ + "static/feature-1-33fe34d04fde4b5a5f1252111f6f5f5a.svg";